"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.embedSiteTreeProvider = void 0;
const siteDataDto_1 = require("../dtos/siteDataDto");
const siteDto_1 = require("../dtos/siteDto");
const Api_1 = require("../utilities/Api");
const SI2_INTERNAL_URL = '/SafetyIntelligence2Internal';
const embedSiteTreeProvider = async ({ apiUrl, }) => {
    const url = apiUrl ?? `${SI2_INTERNAL_URL}/SiteTreeFromHereAndBelow`;
    const mapSiteTreeResponse = (dto) => {
        const parent = {
            title: dto.Name,
            key: dto.Id,
            value: dto.Id,
        };
        parent.children = dto.Children.map((x) => mapSiteTreeResponse(x));
        return parent;
    };
    // TODO: move to server/routes/api once site tree is implemented
    const res = await (0, Api_1.get)({ url });
    const siteTree = res?.SiteTree ? [mapSiteTreeResponse(res.SiteTree)] : [];
    const flatList = res?.SiteFlatList
        ? res.SiteFlatList.map((site) => new siteDto_1.SiteDto({
            id: site.Id,
            parent_id: site.ParentId,
            name: site.Name,
        }))
        : [];
    return new siteDataDto_1.SiteDataDto({ siteTree: siteTree, siteFlatList: flatList });
};
exports.embedSiteTreeProvider = embedSiteTreeProvider;
